import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const virtualAgentSettingsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtual-agent-settings',
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings',
	exact: true,
};
